class FP_Search {
	constructor() {
		this.searchBar = '.fp-search-bar';

		this.controller = new AbortController();
		this.controller.signal.addEventListener("abort", () => {
			document.querySelector(this.searchBar).classList.remove('searching');
		});
		
		this.initEvents();
	}

	initEvents() {
		document.addEventListener('click', function(e) {
			this.handleSearchResultsClose(e);

			this.widenSearchForm(e);
			this.resetSearchForm(e);
		}.bind(this));
		
		this.handleSearch();
	}

	handleSearchResultsClose(e) {
		const openResults = document.querySelector('.fp-search-bar.has-results');
		if (!openResults) {
			return;
		}

		// Do not allow the search results to be closed when clicking within the search form container
		if (e.target.closest('.fp-search-bar')) {
			return;
		}

		openResults.classList.remove('has-results');
		openResults.querySelector('.search-field').value = '';
		openResults.querySelector('.search-results').innerHTML = '';
	}

	debounce(callback, wait) {
		let timeout;
		return (...args) => {
			clearTimeout(timeout);
			timeout = setTimeout(function () { callback.apply(this, args); }, wait);
		};
	}

	/**
	 * Allows the user to search via AJAX
	 * 
	 * @return  mixed
	 */
	handleSearch() {
		if (!this.hasSearchForms())
		{
			return;
		}
		
		const self = this;

		document.addEventListener('keyup', this.debounce((e) => {
			// Abort previous AJAX request
			document.querySelector(this.searchBar).classList.remove('searching');
			this.controller.abort();

			// Set new signal
			this.controller = new AbortController();

			// Check if we can search
			if (!e.target.closest('.fp-search-bar.do-search')) {
				return;
			}

			let search_field = e.target.closest('.search-field');
			if (!search_field) {
				return;
			}

			// Abort empty search term
			if (search_field.value.trim() === '') {
				this.hideResults(e);
				return;
			}

			let search_bar = e.target.closest('.fp-search-bar');
			search_bar.classList.add('searching');

			const post_type = search_bar.querySelector('input[type="hidden"][name="post_type"]') ? search_bar.querySelector('input[type="hidden"][name="post_type"]').value : '';

			let url = new URL(fireplugins.ajax_url);
			let params = {
				s: search_field.value,
				post_type: post_type,
				nonce: search_bar.querySelector('input[type="hidden"][name="nonce"]').value,
				action: 'fp_docs_ajax_search'
			};
			Object.keys(params).forEach(key => url.searchParams.append(key, params[key]))
	
			fetch(url, {
				signal: this.controller.signal
			})
			.then(function(response) {
				return response.json();
			})
			.then((resp) => {
				search_bar.classList.remove('searching');

				if (resp.response != '') {
					self.showResults(e, resp.response);
				} else {
					self.hideResults(e);
				}
			});
		}, 300));
	}

	/**
	 * Shows results
	 * 
	 * @param   {Event}		   e 
	 * @param   {HTMLEleemnt}  results 
	 * 
	 * @return  void
	 */
	showResults(e, results) {
		let search_bar = e.target.closest('.fp-search-bar');

		search_bar.querySelector('.search-results').innerHTML = results;
		search_bar.classList.add('has-results');
	}

	/**
	 * Hides results
	 * 
	 * @param   {Event} e 
	 * 
	 * @return  void
	 */
	hideResults(e) {
		let search_bar = e.target.closest('.fp-search-bar');
		search_bar.classList.remove('has-results');

		let search_results = search_bar.querySelector('.search-results');
		search_results.innerHTML = '';
	}

	/**
	 * Checks whether we have any search forms in the page
	 * 
	 * @return  bool
	 */
	hasSearchForms() {
		return document.querySelectorAll('.fp-search-bar.do-search').length > 0;
	}

	/**
	 * Animates the search form to full width of the parent container.
	 * 
	 * @param   {Event} e 
	 * 
	 * @return  void
	 */
	widenSearchForm(e) {
		let searchBar = e.target.closest(this.searchBar);
		if (!searchBar) {
			return;
		}

		// if its the search icon or result link, allow it to be clicked
		if (e.target.closest('button') || e.target.closest('li')) {
			return;
		}

		e.preventDefault();

		searchBar.classList.add('wide');
	}

	/**
	 * Resets the search form width to the initial state.
	 * 
	 * @param   {Event} e 
	 * 
	 * @return  void
	 */
	resetSearchForm(e) {
		let searchBar = e.target.closest(this.searchBar);
		if (searchBar) {
			return;
		}

		if (!document.querySelector(this.searchBar)) {
			return;
		}

		if (!document.querySelector(this.searchBar).classList.contains('wide')) {
			return;
		}
		
		document.querySelector(this.searchBar).classList.remove('wide');
	}
}